import lineSpinner from '../elements/lineSpinner.js';
lineSpinner.register();
